import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installDiagnostics } from './utils/feedbackDiagnostics';

// Before render, so an error thrown during the first paint is still caught
// and available to a feedback report.
installDiagnostics();

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <div id={'cirrus'}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </div>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.debug);
